(() => {
  const initialized = new WeakSet();
  function initialize(root) {
    if (initialized.has(root)) return;
    initialized.add(root);
    const cards = [...root.querySelectorAll('[data-guide-card]')];
    const filters = root.querySelector('[data-guide-filters]');
    const count = root.querySelector('[data-guide-count]');
    if (filters && cards.length) {
      filters.hidden = false;
      filters.addEventListener('click', event => {
        const button = event.target.closest('button[data-category]');
        if (!button) return;
        const category = button.dataset.category;
        let visible = 0;
        cards.forEach(card => {
          const show = category === 'all' || card.dataset.category === category;
          card.hidden = !show;
          if (show) visible++;
        });
        filters.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        if (count) count.textContent = visible + ' Ratgeber';
      });
    }
    const copy = root.querySelector('[data-guide-copy]');
    const toc = root.querySelector('[data-guide-toc]');
    if (!copy || !toc) return;
    const headings = [...copy.querySelectorAll('h2')];
    const nav = toc.querySelector('ol');
    if (nav && !nav.children.length) {
      const usedIds = new Set([...document.querySelectorAll('[id]')].map(el => el.id));
      headings.forEach((heading, index) => {
        if (!heading.id) {
          let id = 'guide-section-' + (index + 1);
          while (usedIds.has(id)) id += '-x';
          heading.id = id;
          usedIds.add(id);
        }
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = heading.textContent;
        item.append(link);
        nav.append(item);
      });
    }
    const details = toc.querySelector('details');
    const compact = matchMedia('(max-width: 749px)');
    const setToc = () => { if (details) details.open = !compact.matches; };
    setToc();
    compact.addEventListener('change', setToc);
    toc.addEventListener('click', event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest('a[href^="#"]');
      if (!link || !toc.contains(link)) return;
      const target = document.getElementById(link.hash.slice(1));
      if (!target || !root.contains(target)) return;
      event.preventDefault();
      // Avoid Horizon restoring a saved position during native fragment navigation.
      const shell = root.closest('.page-wrapper');
      const scroller = shell && /^(auto|scroll)$/.test(getComputedStyle(shell).overflowY) ? shell : null;
      const margin = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
      const scrollTop = (scroller ? scroller.scrollTop : scrollY) + target.getBoundingClientRect().top - (scroller ? scroller.getBoundingClientRect().top : 0) - margin;
      if (location.hash !== link.hash) history.pushState({scrollTop: Math.max(0, scrollTop)}, '', link.hash);
      target.setAttribute('tabindex', '-1');
      target.focus({preventScroll: true});
      target.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
    });
    root.querySelectorAll('.zw-guide__table-wrap').forEach((wrapper, index) => {
      if (!wrapper.hasAttribute('tabindex')) wrapper.tabIndex = 0;
      if (!wrapper.hasAttribute('role')) wrapper.setAttribute('role', 'region');
      if (!wrapper.hasAttribute('aria-label')) {
        const caption = wrapper.querySelector('caption');
        wrapper.setAttribute('aria-label', caption?.textContent || 'Vergleichstabelle ' + (index + 1));
      }
    });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          nav?.querySelectorAll('a').forEach(link => {
            if (link.hash === '#' + entry.target.id) link.setAttribute('aria-current', 'location');
            else link.removeAttribute('aria-current');
          });
        }
      }, {rootMargin: '-110px 0px -65% 0px'});
      headings.forEach(heading => observer.observe(heading));
    }
    const progress = root.querySelector('[data-guide-progress]');
    const scrollShell = root.closest('.page-wrapper');
    let scheduled = false;
    function updateProgress() {
      scheduled = false;
      if (!progress) return;
      const scrollable = scrollShell && /^(auto|scroll)$/.test(getComputedStyle(scrollShell).overflowY) ? scrollShell : null;
      const viewportTop = scrollable ? scrollable.getBoundingClientRect().top : 0;
      const viewportHeight = scrollable ? scrollable.clientHeight : innerHeight;
      const distance = Math.max(copy.offsetHeight - viewportHeight + 130, 1);
      const amount = Math.min(Math.max((viewportTop - copy.getBoundingClientRect().top + 130) / distance, 0), 1);
      progress.style.transform = 'scaleX(' + amount + ')';
    }
    function schedule() { if (!scheduled) { scheduled = true; requestAnimationFrame(updateProgress); } }
    window.addEventListener('scroll', schedule, {passive: true});
    scrollShell?.addEventListener('scroll', schedule, {passive: true});
    window.addEventListener('resize', schedule, {passive: true});
    updateProgress();
  }
  const scan = () => document.querySelectorAll('[data-guide-root]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, {once: true});
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
